export const CATEGORIES = [
  { id: 'vitres', label: 'Vitres' },
  { id: 'veranda', label: 'Véranda' },
  { id: 'locaux_pro', label: 'Locaux professionnels' },
  { id: 'menage', label: 'Ménage' },
  { id: 'fin_chantier', label: 'Fin de chantier' },
  { id: 'terrasse', label: 'Terrasse' },
  { id: 'textile', label: 'Moquette & textiles' },
  { id: 'autre', label: 'Autre' },
];

export const PRICE_UNITS = [
  { id: 'forfait', label: 'forfait' },
  { id: 'm2', label: 'm²' },
  { id: 'heure', label: 'heure' },
  { id: 'fenetre', label: 'fenêtre' },
  { id: 'metre_lineaire', label: 'mètre linéaire' },
];

export const categoryLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label || id;
export const unitLabel = (id) => PRICE_UNITS.find((u) => u.id === id)?.label || id;

export const formatPrice = (item) =>
  item.pricing_mode === 'fixed' && item.price
    ? `${item.price.toLocaleString('fr-FR')} € / ${unitLabel(item.price_unit)}`
    : 'Sur devis';

export const formatDuration = (min) => {
  if (!min) return '—';
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h ? `${h} h${m ? ` ${String(m).padStart(2, '0')}` : ''}` : `${m} min`;
};

export const EMPTY_ITEM = {
  code: '', name: '', description: '', category: 'autre', pricing_mode: 'quote',
  price: '', price_unit: 'forfait', duration_minutes: '', buffer_minutes: 0,
  direct_booking: false, option_codes: [], tax_credit_eligible: false, show_tax_badge: false,
  active: true, display_order: 0,
};
